// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".DataSamples_dataset-source__1NwGz {\n  padding-left: 1.25rem;\n  padding-bottom: 1rem;\n}", "",{"version":3,"sources":["webpack://src/components/DataSamples/DataSamples.module.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,oBAAA;AACF","sourcesContent":[".dataset-source {\n  padding-left: 1.25rem;\n  padding-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dataset-source": "DataSamples_dataset-source__1NwGz"
};
export default ___CSS_LOADER_EXPORT___;
